<nz-layout class="page-container">
  <nz-header>
    <div style="height: 65px; align-content: center; padding-left: 20px">
      <h3 style="color: #c8dadf"></h3>
    </div>
  </nz-header>
  <nz-content class="content-container">
    <!-- Error Display -->
    <div *ngIf="hasError" class="error-container" style="padding: 20px; margin: 20px; background: #fff2f0; border: 1px solid #ffccc7; border-radius: 6px;">
      <h4 style="color: #cf1322; margin-top: 0;">⚠️ Error Loading Article</h4>
      <p style="color: #cf1322; font-weight: 500;">{{ errorMessage }}</p>
      
      <!-- Debug Information -->
      <div *ngIf="debugMode" style="margin-top: 15px; padding: 10px; background: #f5f5f5; border-radius: 4px;">
        <h5>Debug Information:</h5>
        <pre style="font-size: 12px; overflow: auto; max-height: 200px;">{{ errorStack }}</pre>
        <button nz-button nzType="default" (click)="testForEachError()" style="margin-top: 10px;">
          Test forEach Error
        </button>
        <button nz-button nzType="default" (click)="testUSCError()" style="margin-top: 10px; margin-left: 10px;">
          Test USC Error Detection
        </button>
      </div>
      
      <!-- Action Buttons -->
      <div style="margin-top: 15px;">
        <button nz-button nzType="primary" (click)="retryLoading()">
          Retry Loading
        </button>
        <button nz-button nzType="default" (click)="closeViewer()" style="margin-left: 10px;">
          Close Viewer
        </button>
      </div>
    </div>
    
    <!-- Loading Indicator -->
    <div *ngIf="isLoading && !hasError" class="loading-container" style="padding: 40px; text-align: center;">
      <div class="simple-spinner" style="border: 3px solid #f3f3f3; border-top: 3px solid #1890ff; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto;"></div>
      <p style="margin-top: 20px; color: #666;">Loading article model...</p>
    </div>
    
    <!-- 3D Canvas (only show when not loading and no error) -->
    <article-component-canvas 
      *ngIf="!isLoading && !hasError && canvasInputData" 
      [inputData]="canvasInputData" 
      class="threed">
    </article-component-canvas>
    
    <!-- Debug Panel (only in debug mode) -->
    <div *ngIf="debugMode && !hasError" style="position: fixed; top: 80px; right: 20px; width: 300px; background: white; border: 1px solid #d9d9d9; border-radius: 6px; padding: 15px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); z-index: 1000;">
      <h5 style="margin-top: 0;">Debug Panel</h5>
      <p><strong>Loading:</strong> {{ isLoading }}</p>
      <p><strong>Has Error:</strong> {{ hasError }}</p>
      <p><strong>Canvas Data:</strong> {{ canvasInputData ? 'Available' : 'None' }}</p>
      <p><strong>Article URLs:</strong> {{ jsUrlToPassIn.length || 0 }}</p>
      <p><strong>ObjData Size:</strong> {{ objData.size || 0 }}</p>
      <button nz-button nzType="default" (click)="testForEachError()" size="small" style="margin-top: 10px;">
        Test forEach Error
      </button>
      <button nz-button nzType="default" (click)="testUSCError()" size="small" style="margin-top: 10px; margin-left: 5px;">
        Test USC Error
      </button>
    </div>
  </nz-content>
</nz-layout>

<style>
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
